import { WORKSPACE_CORNER_MARGIN_PX } from '@/features/workspace/workspaceUiLayout';
import type { BlocklyWorkspaceHandle } from '@/features/workspace/BlocklyWorkspace';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton, Paper } from '@mui/material';

interface WorkspaceControlsProps {
  workspaceRef: React.RefObject<BlocklyWorkspaceHandle | null>;
}

export function WorkspaceControls({ workspaceRef }: WorkspaceControlsProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        right: WORKSPACE_CORNER_MARGIN_PX,
        top: WORKSPACE_CORNER_MARGIN_PX,
        zIndex: 20,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          p: 0.5,
          borderRadius: 2,
          bgcolor: 'background.paper',
        }}
      >
        <IconButton
          size="small"
          aria-label="Center view"
          onClick={() => workspaceRef.current?.centerView()}
        >
          <CenterFocusStrongIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          aria-label="Zoom in"
          onClick={() => workspaceRef.current?.zoomIn()}
        >
          <AddIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          aria-label="Zoom out"
          onClick={() => workspaceRef.current?.zoomOut()}
        >
          <RemoveIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Box>
  );
}
